import moment from 'moment-timezone';

// TRIP-188: in June 2023 a Saturday schedule was created with October 2026
// dates by mistake. It sat unnoticed for three years, then took over every
// October Saturday (the newest schedule always wins) and dropped Dupont Circle.
// Creating a schedule this far ahead is still allowed; the admin is asked first.
export const FAR_FUTURE_MONTHS = 6;

// Returns the warning text when `startDate` is more than FAR_FUTURE_MONTHS
// ahead of `now`, otherwise null. Accepts anything moment() accepts.
export function farFutureWarning(startDate, now = moment()) {
  if (!startDate) {
    return null;
  }
  const start = moment(startDate).startOf('day');
  if (!start.isValid() || !start.isAfter(moment(now).add(FAR_FUTURE_MONTHS, 'months'))) {
    return null;
  }
  const monthsAhead = start.diff(now, 'months');
  const years = Math.round(monthsAhead / 12);
  const distance = monthsAhead >= 12
    ? `about ${years} year${years === 1 ? '' : 's'}`
    : `about ${monthsAhead} months`;
  return `This schedule starts ${start.format('MMM D, YYYY')}, ${distance} from now. `
    + 'Schedules created this far ahead can take over the current schedule when their dates arrive.';
}
